module.exports = __webpack_public_path__ + "img/italics.3d878676.png";